// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"506112d1","130":"d27b2712","131":"cefd491e","164":"df9b91bf","284":"81b51987","292":"63628e8a","302":"d58b8ff0","461":"00b595c9","488":"35ba9072","510":"4548a96a","524":"a4b469f7","525":"8ae3430c","566":"3ce6af7c","586":"29555c68","884":"f4b3ec3d","896":"93b84873"}[chunkId] + ".chunk.js";
};